// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager_pager__2Vcem","prev":"pager_prev__31XCY","next":"pager_next__zfrPE","active":"pager_active__22n9v"};